import { Api } from "../Utils/api";
import { CFOP, error99, RetAPI, TEntSai } from "./Types";

export const CfopService = {

    List: async (tipo: TEntSai): Promise<RetAPI> => {

        const resp = await Api('CFOP/List', 'get', { tipo })
        let cfopList: CFOP[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: cfopList
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.cfop) {
                    cfopList = resp.data.cfop.map((item: any) => {
                        return {
                            id: item.codigo,
                            codigo: item.codigo,
                            description: item.descricao,
                        }
                    })
                }
            }


        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: cfopList
            }
        }

        return {
            error: false,
            data: cfopList
        }
    }
}